<template>
  <div>

    <div class = "header-text uk-margin-bottom">
      <h5><b>Game {{game}}:</b> {{ quarter_string }}</h5>
      <h5>{{game_start.format("MMMM DD")}} - {{game_end.format("MMMM DD")}}<b v-if="days_left">:   {{days_left}}</b></h5>
    </div>

    <div class="match">
      <score-board :data="this.data.teams[0]"></score-board>

      <div class='vs'>
        vs.
      </div>

      <score-board :data="this.data.teams[1]"></score-board>
    </div>
  </div>

</template>

<script>

	import ScoreBoard from './Scoreboard'
  import Moment from "moment";

	export default {
		name: "Match",
		components: {
			ScoreBoard,
    },
    props: ["data", "game"],
    computed: {
			game_start: function() {
				return new Moment(this.data.round.starts, "YYYY-MM-DD")
      },
      game_end: function() {
				return new Moment(this.data.round.ends, "YYYY-MM-DD")
      },
      days_left: function() {
				 const days =  this.game_end.diff(new Moment(), 'days')
          if (days > 0) {
          	return days + " days left."
          } else {
          	return null
          }
      },
      quarter_string: function() {
				 const quarter = this.data.round.quarter;

				 switch (quarter) {
           case 1:
           	  return "1st Quarter";

           case 2:
           	  return "2nd Quarter"

           case 3:
           	  return "3rd Quarter"

           case 4:
           	  return "Final"
         }

      }
    }



	}
</script>

<style lang="less" scoped>

  @import "../../../assets/less/palette.less";
  @import "../../../assets/less/theme.less";



      .header-text {
        text-align: center;

        h5 {
          font-size: 17px;
          margin: 2px 0;
        }
    }


  .match {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    //this is necessary to make it fit within the slider!!
    max-width: 77vw;
    margin: auto;
  }


  .vs {
    color: @slate;
    font-size: 3em;
    margin: 0 1em;
  }

  @media (max-width: @breakpoint-medium) {



    .match {
      align-items: center;
      justify-content: center;
      flex-direction: column;
      max-width: 90vw;
      margin: 0;


      .vs {
        display: none;
      }

      & > * {
        margin-top: 1em;
      }

    }
  }

</style>
